import { useState, useEffect, useCallback } from 'react'
import axios from 'axios'
import { getAppConfigSetting } from '../utils'
import { SENTINEL_API } from './constants'
import { IsThirdPartyPayload } from '../types/General'

export const useIsThirdParty = (sourceAccount: string, destinationAccount: string, enabled: boolean = true) => {
  const [isThirdPartyError, setError] = useState<boolean>()
  const [isThirdPartyData, setData] = useState<IsThirdPartyPayload>()
  const [isThirdPartyLoading, setLoading] = useState<boolean>(false)

  const getBaseUrl = () => `${getAppConfigSetting('apiUrl')}${SENTINEL_API}`

  const isThirdPartyMemo = useCallback(() => {
    return axios.get(`${getBaseUrl()}/journals/cash/isThirdParty/${sourceAccount}/${destinationAccount}`, {
      withCredentials: true
    })
  }, [sourceAccount, destinationAccount])

  const handleIsThirdPartyMemo = useCallback(() => {
    setLoading(true)
    setError(false)
    setData(undefined)

    isThirdPartyMemo()
      .then((response) => {
        const { data } = response
        setData(data)
        setLoading(false)
      })
      .catch((_) => {
        setError(true)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [isThirdPartyMemo])

  useEffect(() => {
    if (sourceAccount && destinationAccount && enabled) {
      handleIsThirdPartyMemo()
    }
  }, [sourceAccount, destinationAccount, handleIsThirdPartyMemo, enabled])

  return {
    isThirdPartyData,
    isThirdPartyError,
    isThirdPartyLoading
  }
}
